export const QcActionName = 'actionQcFieldComponent';
